/* ============ Cobelim — scripts MT ============ */
(function () {
  "use strict";

  function initReveals() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("mt-visible");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: "0px 0px 150px 0px" });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initGaleria() {
    var principal = document.querySelector("[data-mt-galeria-principal]");
    var miniaturas = document.querySelectorAll(".mt-miniatura");
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener("click", function () {
        var src = mini.getAttribute("data-src-grande");
        if (!src) return;
        principal.src = src;
        miniaturas.forEach(function (m) { m.classList.remove("mt-activa"); });
        mini.classList.add("mt-activa");
      });
    });
  }

  function initFaq() {
    document.querySelectorAll(".mt-faq-pregunta").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest(".mt-faq-item");
        var respuesta = item.querySelector(".mt-faq-respuesta");
        var abierta = item.classList.contains("mt-abierta");
        document.querySelectorAll(".mt-faq-item.mt-abierta").forEach(function (otro) {
          otro.classList.remove("mt-abierta");
          otro.querySelector(".mt-faq-respuesta").style.maxHeight = null;
          otro.querySelector(".mt-faq-pregunta").setAttribute("aria-expanded", "false");
        });
        if (!abierta) {
          item.classList.add("mt-abierta");
          respuesta.style.maxHeight = respuesta.scrollHeight + "px";
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  function initVariantes() {
    var raiz = document.querySelector("[data-mt-producto]");
    if (!raiz) return;
    var datosEl = document.getElementById("mt-variantes-json");
    if (!datosEl || raiz.dataset.mtUnicaVariante === "true") return;
    var variantes;
    try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }
    var selects = raiz.querySelectorAll("[data-mt-opcion]");
    if (!selects.length) return;
    var inputId = raiz.querySelector('input[name="id"]');
    var precioEl = raiz.querySelector("[data-mt-precio]");
    var boton = raiz.querySelector('[type="submit"][name="add"]');

    function actualizar() {
      var eleccion = [];
      selects.forEach(function (s) { eleccion.push(s.value); });
      var variante = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === eleccion[i]; });
      });
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl && variante.precio) precioEl.innerHTML = variante.precio;
      if (boton) {
        if (variante.disponible) {
          boton.disabled = false;
          boton.classList.remove("mt-prod-agotado");
        } else {
          boton.disabled = true;
          boton.textContent = boton.getAttribute("data-texto-agotado") || "Agotado";
          boton.classList.add("mt-prod-agotado");
        }
      }
    }
    selects.forEach(function (s) { s.addEventListener("change", actualizar); });
  }

  function init() {
    initReveals();
    initGaleria();
    initFaq();
    initVariantes();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
